module.exports = __webpack_public_path__ + "img/ass_result_icon_3.7723cb2e.png";